<template>
  <div>
    <sweet-modal blocking :title="$t('modal_title_editProfile')" ref="myProfile" class="modal">
      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
        <div>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="firstName">
                <el-input v-model="form.firstName" :label="$t('modal_first_name')" size="mini"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="workPhone">
                <el-input type="text" v-model="form.workPhone" :label="$t('modal_work_phone')" size="mini"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="lastName">
                <el-input v-model="form.lastName" :label="$t('modal_last_name')" size="mini"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item type="number" prop="homePhone">
                <el-input v-model="form.homePhone" :label="$t('modal_home_phone')" size="mini"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="email">
                <el-input v-model="form.email" disabled size="mini" :label="$t('modal_email')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item type="number" prop="phone">
                <el-input v-model="form.phone" :label="$t('modal_phone')" size="mini"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="address">
                <el-input v-model="form.address" :label="$t('modal_all_address_fields')" size="mini"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="company">
                <el-input v-model="form.company" :label="$t('modal_company')" size="mini"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-upload
                  class="avatar-uploader"
                  action=""
                  :show-file-list="false"
                  :http-request="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="language">
                <SelectLanguage ref="SelectLanguage"/>
              </el-form-item>

              <el-form-item>
                <el-select v-model="form.timezoneId" :placeholder="$t('modal_timezone')" size="mini" style="width: 100%;">
                  <el-option v-for="item in timezoneList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.gmtOffsetName }}</span>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="modal__btn">
                <el-button v-on:click="$refs.nestedChild.open()" type="primary" plain size="mini" style="width: 100%;">{{$t('modal_btn_change_password')}}</el-button>
              </el-form-item>

              <el-form-item>
                <el-switch
                  v-model="form.mailNotifications"
                  :active-text="$t('modal_receiveEmailNotifications')">
                </el-switch>
              </el-form-item>

              <el-form-item>
                <el-switch
                  v-model="form.companyUserEmailStatus"
                  :active-text="$t('modal_companyEmail')">
                </el-switch>
              </el-form-item>

              <el-form-item v-if="form.companyUserEmailStatus" prop="companyEmail">
                <el-input v-model="form.companyEmail" size="mini" :label="$t('modal_email')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('myProfile')">{{$t('general_cancel')}}</el-button>
          <el-button @click="submitForm('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>

    <sweet-modal ref="nestedChild" v-on:close="closeFormPassword">
      <el-form :model="ruleFormPassword" status-icon :rules="rulesPass" ref="ruleFormPassword" class="demo-ruleForm">
        <el-form-item prop="oldPassword">
          <el-input :label="$t('modal_old_password')" type="password" v-model="ruleFormPassword.oldPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input :label="$t('modal_new_password')" type="password" v-model="ruleFormPassword.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input :label="$t('modal_confirm')" type="password" v-model="ruleFormPassword.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('nestedChild')">{{$t('general_cancel')}}</el-button>
          <el-button type="primary" @click="submitFormPassword('ruleFormPassword')">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form My Profile ] end -->

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
import SelectLanguage from '@/components/SelectLanguage.vue'
export default {
  components: {
    SweetModal,

    SelectLanguage,
  },
  props: ['myProfile', 'directoriesTimezoneList'],
  watch: {
    directoriesTimezoneList(val) {
      this.timezoneList = val
    }
  },
  created() {

  },
  mounted(){

  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.ruleFormPassword.checkPass !== '') {
          this.$refs.ruleFormPassword.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.ruleFormPassword.pass) {
        callback(new Error('Two inputs don\'t match!'));
      } else {
        callback();
      }
    };
    return {
      // value: 'Click Me!',
      // tempValue: null,
      // editing: false,
      ruleFormPassword:{
        oldPassword: '',
        pass: '',
        checkPass: ''
      },
      // Edit Profile
      timezoneList: [],
      form: {
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        workPhone: '',
        homePhone: '',
        phone: '',
        company: '',
        imageUrl: '',
        timezoneId: null,
        mailNotifications: true,
        companyUserEmailStatus: false,
        companyEmail: null,
      },
      rules: {
        firstName: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'blur'
        },
        {
          type: 'email',
          message: this.$i18n.t('modal_settings_invalidEmail')
        }],
        companyEmail: [{
          required: true,
          message: this.$i18n.t('modal_settings_fieldIsRequired'),
          trigger: 'blur'
        },
        {
          type: 'email',
          message: this.$i18n.t('modal_settings_invalidEmail')
        }],

      },
      rulesPass: {
        pass: [
          {min: 8, message: this.$i18n.t('modal_settings_lengthShouldBe8'), trigger: 'blur'},
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          {min: 8, message: this.$i18n.t('modal_settings_lengthShouldBe8'), trigger: 'blur'},
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    itemMe(){
      return new Promise ((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/users/itemMe?companyId=${this.$route.query.companyId}`)
                .then(response => {
                  console.log('---P', response.data);
                  this.form.firstName = response.data.item.firstname;
                  this.form.lastName = response.data.item.lastname;
                  this.form.email = response.data.item.email;

                  this.form.address = response.data.item.address;
                  this.form.workPhone = response.data.item.workPhone;
                  this.form.homePhone = response.data.item.homePhone;
                  this.form.phone = response.data.item.phone;
                  this.form.company = response.data.item.company;
                  this.form.imageUrl = response.data.item.avatarUrl
                  this.form.timezoneId = response.data.item.timezoneId
                  this.form.mailNotifications = response.data.item.mailNotifications

                  this.form.companyUserEmailStatus = response.data.item.companyUserEmailStatus ? response.data.item.companyUserEmailStatus : false
                  this.form.companyEmail = response.data.item.companyEmail
                  resolve('ok')
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  reject(error)
                });
      });
    },
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    handleAvatarSuccess( file, fileList ) {
      console.log("FILE",file);
      // this.form.imageUrl = URL.createObjectURL(file.raw);
      console.log('---', this.form.imageUrl);
      var formData = new FormData();
      formData.append('file', file.file);

      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
        .then(response => {
          console.log('---P', response.data);
          this.form.imageUrl = response.data.fileUrl
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    beforeAvatarUpload(file) {
      const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/webp'].indexOf(file.type) != -1;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('Avatar picture must be JPG format!');
      }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      }
      return isImage && isLt2M;
    },
    async openProfile(){
      try {
        let loader = this.$loading.show();
        await this.itemMe();
        await this.$refs['myProfile'].open();
        this.$refs['SelectLanguage'].value = localStorage.getItem('lang');
        loader.hide()
      }catch(err){
        console.log(err)
      }
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          console.log('submit');
          let loader = this.$loading.show();
          for (let key in this.form) {
            console.log('---', this.form[key]);
            if (this.form[key] === null) {
              this.form[key] = ''
            }
          }
          // console.log(this.form);

          if (!this.form.companyUserEmailStatus) {
            this.form.companyEmail = null
          }

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/users/updateMe?companyId=${this.$route.query.companyId}&companyUserEmailStatus=${this.form.companyUserEmailStatus}`, {
              firstname: this.form.firstName,
              lastname: this.form.lastName,
              address: this.form.address,
              workPhone: this.form.workPhone,
              homePhone: this.form.homePhone,
              phone: this.form.phone,
              company: this.form.company,
              avatarUrl: this.form.imageUrl,
              onlyCompanyNotifications: "0",
              timezoneId: this.form.timezoneId,
              mailNotifications: this.form.mailNotifications,
              companyEmail: this.form.companyEmail
            })
            .then(response => {
              console.log('---P', response.data);
              this.$store.dispatch('getRowDataUsers')
              this.notification("Success", "Edit Profile", "success");
              this.$refs.myProfile.close();
              loader.hide()
              this.$emit('selected', )
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitFormPassword(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                .post('/api/v1/auth/changePassword', {
                 oldPassword: this.ruleFormPassword.oldPassword,
                 newPassword: this.ruleFormPassword.pass
                })
                  .then(response => {
                    console.log('---P', response.data);
                    // this.$store.dispatch('getRowDataUsers')
                    this.notification("Success", "Password changed!", "success");
                    this.$refs.nestedChild.close()
                    loader.hide()
                    })
                    .catch(error => {
                      this.notification("Notification", error.response.data.message, "warning")
                      console.log('An error occurred:', error);
                    loader.hide()
                  })
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    closeFormPassword(){
      this.$refs['ruleFormPassword'].resetFields()
      this.ruleFormPassword.oldPassword = '',
      this.ruleFormPassword.pass = '',
      this.ruleFormPassword.checkPass = ''
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  color: #000000;
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
label {
  width: 100% !important;
}

.table {
  display: flex;
  justify-content: space-around;
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  /*height: 178px;*/
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
